module.exports = __webpack_public_path__ + "img/815F54_DECBC6_301813_C5A8A0-256px.23829b87.png";